import { StackBase } from '@fmc-digital/ui';
import { CircularProgress } from '@mui/material';
import React from 'react';

export const AuthenticationLoader = () => {
    return (
        <StackBase width="100%" height="100%" justifyContent="center" alignItems="center">
            <CircularProgress color="primary" />
        </StackBase>
    );
};
